import { Labels } from '../../shared-components/global/labels';

Labels.set('ui-table-sortable', 'sortBy', 'Sort by');
Labels.set('ui-table-sortable', 'clickToSort', 'Click to sort');
